interface Options {
  title?: string;
  url?: string;
  description?: string;
  image?: string;
  type?: string;
  siteName?: string;
  locale?: string;
}

export default function createSeoMetaInfo(options: Options = {}) {
  const {
    title = '',
    url = '',
    description = '',
    image = '',
    type = 'website',
    siteName = 'Freudenberg Sealing Technologies',
    locale = 'en_US'
  } = options

  return {
    ogTitle: title,
    ogDescription: description,
    ogUrl: url,
    ogImage: image,
    ogType: type,
    ogSiteName: siteName,
    ogLocale: locale
  }
}
